import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import Spacer from 'ui/atoms/spacer';
import { useTranslateWithStringArgs } from 'ui/hooks/use-translate';
import Select from 'ui/atoms/select';
import FormGroup from 'src/ui/molecules/form-group';

export interface FileToUpload {
  file: File | null;
  documentType?: string;
}

interface MultipleFileUploadDocumentTypeProps {
  uploadedFiles?: FileToUpload[];
  documentTypes?: Array<any>;
  showValidatedForm?: boolean;
  onSelectDocumentType?: (documentType: string) => void;
  isDocumentTypeRequired: boolean;
}

export const MultipleFileUploadDocumentType: FunctionComponent<MultipleFileUploadDocumentTypeProps> = ({
  uploadedFiles,
  documentTypes,
  showValidatedForm,
  onSelectDocumentType,
  isDocumentTypeRequired = true,
}) => {
  const translate = useTranslateWithStringArgs();

  if (!documentTypes?.length) return <></>;

  const currentDocumentType = uploadedFiles?.[0]?.documentType;

  const isError = isDocumentTypeRequired && !currentDocumentType && showValidatedForm;

  return (
    <>
      <Spacer y={2} />
      <FormGroup error={isError ? <Translate name="form.errors.required.documentType" /> : null} spacing="none">
        <Select
          required={isDocumentTypeRequired}
          valid={!isDocumentTypeRequired || !!currentDocumentType || !showValidatedForm}
          label={
            isDocumentTypeRequired ? translate('uploadPdf.documentType') : translate('uploadPdf.documentTypeOptional')
          }
          options={documentTypes.map((documentType) => ({
            value: documentType.value || documentType.label,
            label: documentType.label || documentType.value,
          }))}
          value={currentDocumentType}
          onChange={(evt) => {
            onSelectDocumentType && onSelectDocumentType(evt);
          }}
        />
      </FormGroup>
    </>
  );
};

export default MultipleFileUploadDocumentType;
